import { useEffect } from 'react';
import { Redirect } from 'react-router';
import { gaService } from '../../services/gaService';
import { REPORT_GA } from '../../utils/constants';
import { logout } from '../../utils/accessTokenData';
import { getLink, Routes } from '../../utils/router';
import { useIsLoggedIn } from '../../providers/UserProvider';

function Logout() {
  const isLoggedIn = useIsLoggedIn();
  useEffect(() => {
    logout();
    gaService.sendEvent({
      action: REPORT_GA.GA_EVENT_ACTION_SUCCESS,
      label: REPORT_GA.GA_EVENT_LABEL_NA,
      category: REPORT_GA.GA_EVENT_CATEGORY_LOGOUT,
    }, {
      // End google analytics session
      sc: 'end',
    });
  }, []);

  return (!isLoggedIn && <Redirect to={getLink(Routes.Public)} />);
}

export default Logout;
